import { LazyQueryHookOptions } from '@apollo/client';

import {
  BannerConfigurationEdge,
  BannerConfigurationFragment,
  BannerConfigurationsQuery,
  BannerConfigurationsQueryVariables,
  useBannerConfigurationsLazyQuery,
} from '@occc/graphql';

import { useLazyQuery } from '../utils';

const transformDataToBannerConfigurationsArray = (
  data: BannerConfigurationsQuery,
): BannerConfigurationFragment[] | null => {
  return data?.bannerConfigurations?.edges
    ? data?.bannerConfigurations?.edges?.map((edge: BannerConfigurationEdge) => edge.node)
    : null;
};

export const useGetExternalLoyaltyBannersLazy = (
  baseOptions?: LazyQueryHookOptions<BannerConfigurationsQuery, BannerConfigurationsQueryVariables>,
) => {
  const [executeQuery, response] = useLazyQuery(useBannerConfigurationsLazyQuery, baseOptions);

  return {
    executeQuery,
    response: {
      ...response,
      data: response.data ? transformDataToBannerConfigurationsArray(response.data) : response.data,
    },
  };
};
